import { useState } from 'react';
import { Switch, Route, Link, withRouter, useParams, useLocation, } from 'react-router-dom';
import { useSelector } from "react-redux";
// css
import "./dashboard.css"
// other assets
import webLogo from "assets/Images/icons/dashboardLogo.png";
import notificationAvailIcon from "assets/Images/icons/notificationAvail.png";
import dashboardIcon from "assets/Images/icons/dashboard.png";
import settingIcon from "assets/Images/icons/AdmnSettingsIcon.png";
import adminBoatIcon from "assets/Images/icons/adminBoatIcon.png";
import adminTabUsersIcon from "assets/Images/icons/adminTabUsers.png";
import analiticsIcon from "assets/Images/icons/analitics.png";
import blogsIcon from "assets/Images/icons/blogsIcon.png";
import dealTag from "assets/Images/icons/dealTag.png";
import arrowDownImg from "assets/Images/icons/blueArrowDown.png";
import { Menu, Close } from "@material-ui/icons";
// ==========================
// Admin Pages
// All Inclusive pages
import AllInCLusivePage from "Components/AdminComponents/AllInclusive/OffersList"
import AddNew from "Components/AdminComponents/AllInclusive/AddNew/AddNew"
import OfferRequests from "Components/AdminComponents/AllInclusive/OfferRequests/OfferRequests"
// Dashboard default page or dashboard Home page
import DashboardHome from "Components/AdminComponents/DashboardHome"
import Loader from 'Components/others/Loader';
import NotLoggedIn from "Components/notLoggedIn";


// ===================== Admin page wrapper main 
const AdminPage = () => {
    const { tabName, subTabName } = useParams();
    const { pathname } = useLocation();
    const [sideBarOpen, setSideBar] = useState(false)
    // ================ getting user from redux =================
    const user = useSelector(state => state.current_user);
    if (user && user?.isAuth) {
        return (
            <>
                {sideBarOpen &&
                    <div onClick={() => setSideBar(false)} className="shadow-of-sidebar"></div>}
                {/*  */}
                <div className="adminDashboard_page">
                    <div className="dashboardContainer">
                        {/* left sidebar */}
                        <aside className={`dashboard_sideBar ${sideBarOpen ? ' dashboardSideBar_opened' : ""}`}>
                            <Link to="/" className="dashboard_logo">
                                <img src={webLogo} alt="CYAN" />
                            </Link>
                            <nav className={`dashboard_nav  `}>
                                {/* All dashboard links */}
                                <Link className={`${tabName === "home" || pathname === "/dashboard" || pathname === "/dashboard/" ? "activeLinkDashTab" : ""} dashboardLinks`} to={`/dashboard/home`}><img src={dashboardIcon} alt="" /> </Link>
                                <div className="dashboardLinks">
                                    <span className={`${tabName?.includes('offers') ? "activeLinkDashTab" : ""} mt-1  w-100`}>
                                        <img src={dealTag} alt="" />
                                    </span>
                                    <div className={`innerTabsLinks`}>
                                        <Link className={`${subTabName === "requests" ? "text-white " : ""} dashboardLinks`} to={`/dashboard/offers/requests`}>Requests (20) </Link>
                                        <Link className={`${subTabName === "allInclusive" ? "text-white " : ""} dashboardLinks`} to={`/dashboard/offers/allInclusive`}>All Inclusive </Link>
                                        <Link className={`${subTabName === "createNew" ? "text-white " : ""} dashboardLinks`} to={`/dashboard/offers/createNew`}>Create new</Link>
                                    </div>
                                </div>
                                <Link className={`${tabName === "boats" ? "activeLinkDashTab" : ""} dashboardLinks`} to={`/dashboard/boats`}><img src={adminBoatIcon} alt="" /></Link>
                                <Link className={`${tabName === "users" ? "activeLinkDashTab" : ""} dashboardLinks`} to={`/dashboard/users`}><img src={adminTabUsersIcon} alt="" />  </Link>
                                <Link className={`${tabName === "blogs" ? "activeLinkDashTab" : ""} dashboardLinks`} to={`/dashboard/blogs`}><img src={blogsIcon} alt="" />  </Link>
                                <Link className={`${tabName === "analytics" ? "activeLinkDashTab" : ""} dashboardLinks`} to={`/dashboard/analytics`}><img src={analiticsIcon} alt="" />  </Link>
                            </nav>
                            <div className="mt-auto py-3">
                                <Link className={`${tabName === "settings" ? "activeLinkDashTab" : ""} dashboardLinks`} to={`/dashboard/settings`}><img src={settingIcon} alt="" />  </Link>
                            </div>
                        </aside>
                        <main className="dashboard_right_col_main">
                            {/* dashboard Header */}
                            <header className="dashboard_header">
                                <div className="dashboard_container d-flex justify-content-start align-items-center">
                                    <div className="dashboardMenuOpen" onClick={() => setSideBar(!sideBarOpen)}>
                                        {sideBarOpen ? <Close />
                                            : <Menu />}
                                    </div>
                                    <div className="dashboardToolbar">
                                        <div className="toolbarIconBox">
                                            <img src={notificationAvailIcon} alt="" />
                                        </div>
                                        <div className="toolbarIconBox adminAvatarBox">
                                            <img className="adminAvatar" src={user?.profileImg} alt={user?.first_name?.slice(0, 1)} />
                                            <div className="openMenuProfileBtn">
                                                <img src={arrowDownImg} alt="" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </header>
                            <div className="dashboard_container">
                                <Switch>
                                    <Route path={`/dashboard/`} exact component={DashboardHome} />
                                    <Route path={`/dashboard/home`} exact component={DashboardHome} />
                                    <Route path={`/dashboard/offers/requests`} component={OfferRequests} />
                                    <Route path={`/dashboard/offers/allInclusive`} exact component={AllInCLusivePage} />
                                    <Route path={`/dashboard/offers/createNew`} component={AddNew} />
                                    <Route path={`/dashboard/boats`} component={BoatManage} />
                                    <Route path={`/dashboard/users`} component={Users} />
                                    <Route path={`/dashboard/blogs`} component={Blogs} />
                                    <Route path={`/dashboard/analytics`} component={Analytics} />
                                    <Route path={`/dashboard/settings`} component={Settings} />
                                </Switch>
                            </div>
                        </main>
                    </div>
                </div>
            </>
        );
    }
     else if (user?.isLoading) {
        return (
            <div className="my-5  py-5">
                <div className="container py-5 mt-5 mb-5">
                    <Loader />
                </div>
            </div>
        )
    }
    else {
        //================== not logged in =====================
        return (
            <NotLoggedIn />
        )
    }
};

// Demo pages just for development
const BoatManage = () => <div>BoatManage</div>;
const Users = () => <div>Users</div>;
const Blogs = () => <div>Blogs</div>;
const Analytics = () => <div>Analytics</div>;
const Settings = () => <div>Settings</div>;

export default withRouter(AdminPage);
